export const AUTH_TOKEN = "token";
export const USER_ROLE = "role";
export const USER_PHONE = "phone";
